import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PreheatIssuesManager} from '@github-ui/preheat-issues-manager'
import {observe} from '@github-ui/selector-observer'
import {isLoggedIn} from '@github-ui/client-env'

const manager = new PreheatIssuesManager({
  isEnabled: () => !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn(),
  source: 'notifications',
})

manager.start()

// Buffer preheat event data on window so that events fired before the
// React listener registers are not lost.  The consumer replays
// this buffer when it mounts.
type PreheatEventDetail = {href: string | null}
declare global {
  interface Window {
    __preheatEventBuffer?: PreheatEventDetail[]
  }
}
window.__preheatEventBuffer = window.__preheatEventBuffer ?? []

observe('.notification-list-item-link', {
  initialize: el => {
    const detail: PreheatEventDetail = {href: el.getAttribute('href')}

    // Always push to the buffer so late-mounting listeners can replay.
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    window.__preheatEventBuffer!.push(detail)

    // Also dispatch the live event for listeners that are already registered.
    window.dispatchEvent(new CustomEvent('issue-link-to-preheat', {detail}))
  },
})
